import { COVERAGE_DATE_MAX_DAYS_IN_FUTURE } from 'src/pages/QuoteInformation/QuoteInformationForm';

export const getCoverageInputRanges = () => {
  return {
    minDate: new Date(),
    maxDate: new Date(
      new Date().setDate(
        new Date().getDate() + COVERAGE_DATE_MAX_DAYS_IN_FUTURE,
      ),
    ),
  };
};
